//bookStack.js
export function mountBookStack({
  root = document,
  booksData = {},
  onSelectBook,
  onCloseViewer,
  enableHover = true,
} = {}) {
  const wrap = root.querySelector('[data-bookstack]');
  if (!wrap) return { destroy() {} };

  const stack = wrap.querySelector('.bookstack-stack');
  const viewer = wrap.querySelector('.bookstack-viewer');
  const pagesEl = wrap.querySelector('.book-pages');
  const closeBtn = wrap.querySelector('.btn-close');
  const books = Array.from(wrap.querySelectorAll('.btn-book'));
  if (!stack || !viewer || !pagesEl || !books.length) return { destroy() {} };

  const viewerImg = document.createElement('img');
  viewerImg.decoding = 'async';
  viewerImg.loading = 'lazy';
  viewerImg.alt = '';
  viewerImg.hidden = true;
  pagesEl.appendChild(viewerImg);

  function layoutBooks(hoverIndex = -1) {
    const baseStep = 36;
    const compressStep = 18;
    const extraPull = 70;

    books.forEach((btn, i) => {
      const isHover = i === hoverIndex;
      btn.classList.toggle('is-hover', isHover);

      if (hoverIndex < 0 || hoverIndex === 0 || i === 0) {
        btn.style.transform = '';
        return;
      }

      let x;
      if (i < hoverIndex) x = baseStep * i;
      else if (i === hoverIndex) x = baseStep * i + extraPull;
      else
        x = baseStep * hoverIndex + extraPull + compressStep * (i - hoverIndex);

      btn.style.transform = `translateX(${x}%)`;
    });
  }

  // 페이지 상태
  let selectedBook = -1;
  let pageIndex = 0;

  function getPages(bookIndex) {
    return booksData?.[String(bookIndex)] || [];
  }

  function renderPage() {
    const pages = getPages(selectedBook);

    if (selectedBook < 0 || pages.length === 0) {
      wrap.dataset.state = 'idle';
      wrap.dataset.selected = '-1';

      viewerImg.hidden = true;
      viewerImg.removeAttribute('src');
      viewerImg.alt = '';
      return;
    }

    wrap.dataset.state = 'selected';
    wrap.dataset.selected = String(selectedBook);

    const src = pages[pageIndex] || pages[0];

    if (viewerImg.getAttribute('src') !== src) {
      viewerImg.src = src;
    }
    viewerImg.alt = `책자 ${selectedBook} 페이지 ${pageIndex + 1}`;
    viewerImg.hidden = false;
  }

  function selectBook(bookIndex) {
    selectedBook = bookIndex;
    pageIndex = 0;
    renderPage();

    onSelectBook?.(bookIndex);
  }

  function nextPage() {
    const pages = getPages(selectedBook);
    if (!pages.length) return;
    pageIndex = (pageIndex + 1) % pages.length;
    renderPage();
  }

  function resetViewer() {
    selectedBook = -1;
    pageIndex = 0;
    wrap.dataset.state = 'idle';
    wrap.dataset.selected = '-1';

    viewerImg.hidden = true;
    viewerImg.removeAttribute('src');
    viewerImg.alt = '';

    onCloseViewer?.();
  }

  function closeViewer(e) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    resetViewer();
  }

  function onBookClick(e) {
    const btn = e.target.closest('.btn-book');
    if (!btn || !wrap.contains(btn)) return;
    e.preventDefault();

    const idx = Number(btn.dataset.book);
    if (!Number.isFinite(idx)) return;

    selectBook(idx);
  }

  function onViewerClick(e) {
    if (selectedBook < 0) return;
    nextPage();
  }

  // 초기화
  layoutBooks(-1);

  let enterHandlers = [];
  let onLeave = null;

  if (enableHover) {
    enterHandlers = books.map((btn, index) => {
      const onEnter = () => layoutBooks(index);
      btn.addEventListener('pointerenter', onEnter);
      return () => btn.removeEventListener('pointerenter', onEnter);
    });
    onLeave = () => layoutBooks(-1);
    stack.addEventListener('pointerleave', onLeave);
  }

  stack.addEventListener('click', onBookClick);
  viewer.addEventListener('click', onViewerClick);

  if (closeBtn) {
    closeBtn.addEventListener('click', closeViewer);
  }

  return {
    destroy() {
      enterHandlers.forEach((off) => off());
      if (onLeave) stack.removeEventListener('pointerleave', onLeave);

      stack.removeEventListener('click', onBookClick);
      viewer.removeEventListener('click', onViewerClick);
      closeBtn?.removeEventListener('click', closeViewer);

      resetViewer();
    },
  };
}
